import { PRIMARY_COLOR } from "../Services/Colors";
export const MaskIcon = ({
  src,
  width = 18,
  height = 18,
  onClick,
  color = PRIMARY_COLOR,
  style = {},
}) => (


  <div
    style={{
      width,
      height,
      backgroundColor: color,
      WebkitMaskImage: `url(${src})`,
      WebkitMaskPosition: "center center",
      WebkitMaskSize: "contain",
      WebkitMaskRepeat: "no-repeat",
      maskImage: `url(${src})`,
      maskPosition: "center center",
      maskSize: "contain",
      maskRepeat: "no-repeat",
      display: "block",
      flexShrink: 0,
      ...style,
    }}
    onClick={onClick}
  />
);